import React from 'react'
import { OrderStatus as OrderStatusEntries } from '@ztechapps/order.common'
import { StatusColorBadge, StatusColorDot, findStatus } from '@ztechapps/webui.util'

export type OrderStatusProps = { status: string }
export type OrderStatusBadgeProps = OrderStatusProps & { className?: string }

export const OrderStatusBadge = ({ status, className }: OrderStatusBadgeProps) => (
  <StatusColorBadge status={status} color={findStatus(OrderStatusEntries, status)} className={className} />
)

export const OrderStatus = ({ status }: OrderStatusProps) => (
  <StatusColorDot value={status} color={findStatus(OrderStatusEntries, status)} />
)
